<template>
  <v-container grid-list-md>
    <h1>Base Words</h1>
    <v-layout row wrap>
      <v-flex xs4 sm2 d-flex>
        <v-btn
                v-on:click="create"
        >
          <v-icon>add</v-icon>
          Add word
        </v-btn>
      </v-flex>
      <v-flex xs6 sm4 d-flex>
        <v-select
                :items="categories"
                v-model="categoryId"
                item-text="fullName"
                item-value="id"
                placeholder="All categories"
                clearable
                label="Category"
        ></v-select>
      </v-flex>
      <v-flex offset-sm2 xs6 sm4 d-flex>
        <v-text-field
                label="Search"
                append-icon="search"
                v-model="search"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <BaseWordsList :words="words" v-on:change="edit" v-on:menu="showWordMenu"></BaseWordsList>
    <BaseWordMenu
            v-model="activeWordMenu"
            :x="menuX"
            :y="menuY"
            :word="model"
            v-on:edit="showEditor"
    ></BaseWordMenu>
    <v-layout row wrap style="padding: 24px 0;">
      <v-flex xs1>
        <v-select
                v-model="rowsPerPage"
                :items="[18, 36, 72]"
                hide-details
                style="padding-top: 0; width: 64px;"
        ></v-select>
      </v-flex>
      <v-flex xs11>
        <div class="text-xs-center">
          <v-pagination
                  v-model="page"
                  :length="pages"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    <ImageSelector v-model="selector" :suggest="suggest" v-on:select="changeImage"/>
    <BaseWordDialog v-model="dialog" :model="model"></BaseWordDialog>

  </v-container>
</template>

<script>
import ImageSelector from '../components/ImageSelector'
import BaseWordsList from '../components/BaseWordsList'
import { WordsApi } from '../common/api'
import { LOADING_END, LOADING_START, UPDATE_WORD } from '../store/mutation-types'
import { mapState, mapGetters } from 'vuex'
import debounce from 'lodash/debounce'
import BaseWordMenu from '../components/BaseWordMenu'
import BaseWordDialog from '../components/BaseWordDialog'
import { FETCH_SOURCE_WORDS } from '../store/action-types'

export default {
  components: { BaseWordDialog, BaseWordMenu, BaseWordsList, ImageSelector },
  data () {
    return {
      dialog: false,
      model: null,
      selector: false,
      categoryId: undefined,
      rowsPerPage: 18,
      page: 1,
      search: null,
      activeWordMenu: false,
      menuX: 0,
      menuY: 0
    }
  },
  computed: {
    suggest () {
      return this.model ? this.model.text : null
    },
    ...mapState([
      'words',
      'pages',
      'errorOnLoad',
      'categories',
      'sourceDictionary'
    ]),
    ...mapGetters([
      'isLoading'
    ])
  },
  created () {
    this.debouncedFetchWords = debounce(this.fetchWords, 100)
    this.debouncedFetchWordsForTyping = debounce(this.fetchWords, 800)

    this.debouncedFetchWords()
  },
  watch: {
    categoryId () {
      this.page = 1
      this.debouncedFetchWords()
    },
    page () {
      this.debouncedFetchWords()
    },
    search () {
      this.page = 1
      this.debouncedFetchWordsForTyping()
    },
    rowsPerPage () {
      this.page = 1
      this.debouncedFetchWords()
    }
  },
  methods: {
    edit (model) {
      this.model = model
      this.selector = true
    },
    async changeImage (image) {
      const model = { ...this.model }
      const oldImage = model.image
      model.image = image
      this.$store.commit(UPDATE_WORD, model)
      this.$store.commit(LOADING_START, UPDATE_WORD)
      try {
        const { data } = await WordsApi.update(model)
        this.$store.commit(UPDATE_WORD, data)
      } catch (e) {
        model.image = oldImage
        this.$store.commit(UPDATE_WORD, model)
        alert(`Ошибка при сохранении картинки для слова "${model.text}"`)
      } finally {
        this.$store.commit(LOADING_END, UPDATE_WORD)
      }
    },
    async fetchWords () {
      await this.$store.dispatch(FETCH_SOURCE_WORDS, this.createQueryParams())
    },
    createQueryParams () {
      return {
        sourceDictionaryId: this.sourceDictionary.id,
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        categoryId: this.categoryId,
        search: this.search,
        sortBy: 'position'
      }
    },
    showWordMenu (e, word) {
      e.preventDefault()
      this.activeWordMenu = false
      this.menuX = e.clientX
      this.menuY = e.clientY

      this.model = word
      this.$nextTick(() => {
        this.activeWordMenu = true
      })
    },
    showEditor () {
      this.dialog = true
    },
    create () {
      this.model = null
      this.dialog = true
    }
  }
}
</script>
